export const teacherClass = {
    "teacher_class_my_classes": "My Classes",
    "teacher_class_search_placeholder": "Search class name or description",
    "teacher_class_no_classes": "No classes",
    "teacher_class_view_detail": "View Details",
    "teacher_class_start_time": "Start Time",
    "teacher_class_end_time": "End Time",
    "teacher_class_status_init": "Initialized",
    "teacher_class_status_running": "Running",
    "teacher_class_status_end": "Ended",
    "teacher_class_status_disabled": "Disabled",
    "teacher_class_status_completed": "Completed",
    "teacher_class_status_wait_grade": "Waiting for Grade",
    "teacher_class_status_submitted": "Submitted",
    "teacher_class_status_in_progress": "In Progress",
    "teacher_class_msg_fetch_error": "Failed to fetch class list",
    "teacher_class_msg_fetch_detail_error": "Failed to fetch class detail",
    "teacher_class_msg_fetch_students_error": "Failed to fetch students",
    "teacher_class_msg_fetch_homeworks_error": "Failed to fetch homeworks",
    "teacher_class_msg_fetch_homework_banks_error": "Failed to fetch homework banks",
    "teacher_class_msg_fetch_homework_details_error": "Failed to fetch homework details",
    "teacher_class_msg_create_homework_success": "Homework created successfully",
    "teacher_class_msg_create_homework_error": "Failed to create homework",
    "teacher_class_msg_delete_homework_success": "Homework deleted successfully",
    "teacher_class_msg_delete_homework_error": "Failed to delete homework",
    "teacher_class_msg_update_homework_success": "Homework updated successfully",
    "teacher_class_msg_update_homework_error": "Failed to update homework",
    "teacher_class_msg_select_homework_temp": "Please select a homework template",
    "teacher_class_msg_select_subject": "Please select a subject",
    "teacher_class_detail_basic_info": "Basic Information",
    "teacher_class_detail_teachers": "Teachers",
    "teacher_class_detail_students": "Students",
    "teacher_class_detail_homeworks": "Homeworks",
    "teacher_class_detail_statistics": "Statistics",
    "teacher_class_detail_name": "Class Name",
    "teacher_class_detail_status": "Status",
    "teacher_class_detail_start_time": "Start Time",
    "teacher_class_detail_end_time": "End Time",
    "teacher_class_detail_desc": "Description",
    "teacher_class_no_teachers": "No teachers",
    "teacher_class_no_students": "No students",
    "teacher_class_no_homeworks": "No homeworks",
    "teacher_class_no_homework_banks": "No homework banks",
    "teacher_class_no_statistics": "No statistics",
    "teacher_class_column_name": "Name",
    "teacher_class_column_email": "Email",
    "teacher_class_column_remark_name": "Remark Name",
    "teacher_class_column_subjects": "Subjects",
    "teacher_class_column_subject": "Subject",
    "teacher_class_column_description": "Description",
    "teacher_class_column_status": "Status",
    "teacher_class_column_actions": "Actions",
    "teacher_class_column_homework_name": "Homework Name",
    "teacher_class_column_total_students": "Total Students",
    "teacher_class_column_answered_count": "Answered",
    "teacher_class_column_unanswered_count": "Unanswered",
    "teacher_class_column_has_answer": "Has Answer",
    "teacher_class_column_score": "Score",
    "teacher_class_column_answer_id": "Answer ID",
    "teacher_class_create_homework": "Create Homework",
    "teacher_class_view_details": "View Details",
    "teacher_class_enable": "Enable",
    "teacher_class_disable": "Disable",
    "teacher_class_enabled": "Enabled",
    "teacher_class_disabled": "Pending Enable",
    "teacher_class_delete": "Delete",
    "teacher_class_delete_disabled_tooltip": "This homework cannot be deleted because students have submitted answers",
    "teacher_class_edit_name": "Edit Name",
    "teacher_class_edit_homework_name": "Edit Homework Name",
    "teacher_class_save": "Save",
    "teacher_class_all_subjects": "All Subjects",
    "teacher_class_search_homework": "Search homework",
    "teacher_class_modal_title": "Class Details: {{name}}",
    "teacher_class_homework_details": "Homework Details",
    "teacher_class_homework_basic_info": "Homework Basic Information",
    "teacher_class_homework_use_time": "Estimated Time",
    "teacher_class_minutes": "minutes",
    "teacher_class_student_completion_stats": "Student Completion Statistics",
    "teacher_class_total_students": "Total Students",
    "teacher_class_answered_count": "Answered",
    "teacher_class_unanswered_count": "Unanswered",
    "teacher_class_average_score": "Average Score",
    "teacher_class_student_answers": "Student Answers",
    "teacher_class_total": "Total {{total}}",
    "teacher_class_yes": "Yes",
    "teacher_class_no": "No",
    "teacher_class_no_data": "No data",
    "teacher_class_select_subject": "Select Subject",
    "teacher_class_select_subject_placeholder": "Please select a subject",
    "teacher_class_select_homework_temp": "Select Homework Template",
    "teacher_class_homework_name": "Homework Name",
    "teacher_class_homework_name_placeholder": "Leave empty to use template name",
    "teacher_class_homework_description": "Homework Description",
    "teacher_class_homework_description_placeholder": "Please enter homework description",
    "teacher_class_homework_enable": "Enable Immediately",
    "teacher_class_stat_total_homework": "Total Homeworks",
    "teacher_class_stat_enabled_homework": "Enabled Homeworks",
    "teacher_class_stat_disabled_homework": "Pending Enable Homeworks",
    "teacher_class_stat_student_count": "Total Students",
    "loading": "Loading...",
    "teacher_class_enter_class": "Enter Class",
    "teacher_class_go_to_class_manager": "Go to Class Management",
    "teacher_class_go_to_class_manager_desc": "Admins can manage all classes, teachers and students here",
    "teacher_class_view_mode_cards": "Card View",
    "teacher_class_view_mode_list": "List View",
    "teacher_class_student_count": "Student Count",
    "teacher_class_detail_info": "Class Details",
    "teacher_class_homework_list": "Homework List",
    "teacher_class_homework_bank": "Homework Bank",
    "teacher_class_homework_template": "Homework Template",
    "teacher_class_view_homework_bank": "View Homework Bank",
    "teacher_class_view_template": "View Template",
    "teacher_class_select_template": "Select Template",
    "teacher_class_bank_type_public": "Public Homework Bank",
    "teacher_class_bank_type_teacher": "Personal Homework Bank",
    "teacher_class_bank_type_class": "Class Homework Bank",
    "teacher_class_bank_list": "Homework Bank List",
    "teacher_class_template_list": "Homework Template List",
    "teacher_class_search_template": "Search template name",
    "teacher_class_search_homework_bank": "Search homework bank name or description",
    "teacher_class_no_templates_search_empty": "No matching templates found",
    "teacher_class_no_homework_banks_search_empty": "No matching homework banks found",
    "teacher_class_back": "Back",
    "teacher_class_select": "Select",
    "teacher_class_view_detail_btn": "View Details",
    "teacher_class_create_homework_sub": "Create Homework",
    "teacher_class_create": "Create",
    "teacher_class_cancel": "Cancel",
    "teacher_class_no_homework_banks_empty": "No homework banks",
    "teacher_class_no_templates_empty": "No templates in this bank",
    "teacher_class_no_template_content": "No template content",
    "teacher_class_template_detail": "Homework Template Details",
    "teacher_class_msg_load_public_banks_error": "Failed to load public homework banks",
    "teacher_class_msg_load_teacher_banks_error": "Failed to load personal homework banks",
    "teacher_class_msg_load_class_banks_error": "Failed to load class homework banks",
    "teacher_class_msg_load_templates_error": "Failed to load template list",
    "teacher_class_msg_load_template_detail_error": "Failed to load template details",
    "teacher_class_msg_select_bank_first": "Please select a homework bank first",
    "teacher_class_msg_load_data_error": "Failed to load data",
    "teacher_class_msg_get_class_info_error": "Failed to get class information",
    "teacher_class_msg_no_subject_permission": "Cannot create homework",
    "teacher_class_msg_no_subject_permission_desc": "You have not been assigned subjects in this class. Please contact the administrator to assign subjects before creating homework.",
    "teacher_class_msg_template_selected": "Template selected, please fill in homework information",
    "teacher_class_msg_homework_name_required": "Please enter homework name",
    "teacher_class_view_student_info": "View Student Info",
    "teacher_class_view_student_info_msg": "View student {{name}} information",
    "teacher_class_view_answer_detail": "View Answer Detail",
    "teacher_class_select_student_to_view": "Please select a student to view answer details",
    "teacher_class_student_no_answer": "This student has not submitted an answer",
    "teacher_class_answer_basic_info": "Answer Basic Information",
    "teacher_class_questions_and_answers": "Questions and Answers",
    "teacher_class_student_answer": "Student Answer",
    "teacher_class_question_score": "Score",
    "teacher_class_true": "True",
    "teacher_class_false": "False",
    "teacher_class_no_answer": "Not Answered",
    "teacher_class_homework_questions": "Homework Questions",
    "teacher_class_student_answer_detail": "Student Answer Detail",
    "teacher_class_wait_read": "Pending Review",
    "teacher_class_msg_fetch_student_answer_error": "Failed to fetch student answer details",
    "teacher_class_grade_btn": "Grade",
    "teacher_class_grade_title": "Grade Homework",
    "teacher_class_grade_correct": "Correct",
    "teacher_class_grade_incorrect": "Incorrect",
    "teacher_class_grade_half_correct": "Partially Correct",
    "teacher_class_grade_custom": "Custom",
    "teacher_class_grade_correctness": "Correctness",
    "teacher_class_grade_score": "Score",
    "teacher_class_grade_desc": "Grade Note",
    "teacher_class_grade_desc_placeholder": "Enter grade note (optional)",
    "teacher_class_grade_submit": "Submit Grade",
    "teacher_class_grade_no_need": "No questions need grading",
    "teacher_class_grade_no_answer": "Answer record not found",
    "teacher_class_grade_success": "Graded successfully",
    "teacher_class_grade_error": "Failed to grade",
    "teacher_class_grade_pending_title": "Pending Grading",
    "teacher_class_grade_pending_count": "Pending",
    "teacher_class_grade_pending_unit": "items",
    "teacher_class_grade_no_pending": "No homework pending grading",
    "teacher_class_grade_load_error": "Failed to load pending list",
    "teacher_class_grade_class": "Class",
    "teacher_class_stat_completed": "Completed",
    "teacher_class_stat_completion_rate": "Completion Rate",
    "teacher_class_stat_avg_score_rate": "Avg Score Rate",
    "teacher_class_stat_ranking": "Student Ranking",
    "teacher_class_stat_rank": "Rank",
    "teacher_class_stat_total_score": "Total Score",
    "teacher_class_stat_avg_completion": "Avg Completion",
    "teacher_class_stat_homework_count": "Homeworks",
    "teacher_class_stat_homework_score_chart": "Avg Score Rate by Homework",
    "teacher_class_stat_finished": "finished",
    "teacher_class_student_detail_stats": "Student Detail Statistics",
    "teacher_class_no_subject_stats": "No homework statistics for this subject",
    "teacher_class_filter_all": "All",
    "teacher_class_filter_wait_grade": "Pending Grading",
    "teacher_class_filter_completed": "Completed",
    "teacher_class_filter_in_progress": "In Progress",
    "teacher_class_filter_no_answer": "Not Answered",
    "teacher_class_answer_statistics_tab": "Answer Statistics",
    "teacher_class_answer_detail_tab": "Answer Details",
    "teacher_class_grade_list_title": "Pending Grading List",
    "teacher_class_grade_regrade_btn": "Regrade",
    "teacher_class_grade_regrade_title": "Regrade Homework",
    "teacher_class_grade_regrade_warning": "This homework has already been graded. You are regrading it; submitting will overwrite the previous grades.",
    "teacher_class_grade_regrade_confirm_title": "Confirm Regrade",
    "teacher_class_grade_regrade_confirm_content": "Regrading will overwrite the student's previous scores and notes. Continue?",
    "teacher_class_grade_page_title": "Grade Homework",
    "teacher_class_grade_show_auto_scored": "Show auto-scored questions (read-only)",
    "teacher_class_grade_auto_scored_tag": "Auto-scored",
    "teacher_class_grade_needs_grade_tag": "Needs grading",
};
